import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { DialogService } from "@eforall/dashboard";
import { PersonDialog } from "../../../../../ui/widget/person-dialog";
import { EventDialogDataService } from "../event-dialog-data.service";

@Component({
	selector: 'event-details-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './details.part.html'
})
export class EventDetailsPart {

	private readonly util = inject(UtilityService);
	public readonly dialogDataService = inject(EventDialogDataService);
	private dialogService = inject(DialogService);

	public eventDetails = computed(() => {
		const event = this.dialogDataService.event();
		if (!event) return undefined;
		return {
			accName: event.accName,
			eventTime: this.util.date.formatUTC(event.startUTC, 'DOW MMM D, YYYY', 'H:MM AM EST', 'en-US'),
			duration: this.util.date.calculateTimePeriod(event.startUTC, event.endUTC),
			hostName: event.hostFullName,
			hostPersonId: event.hostPersonId,
			venue: event.venue ? {
				venueId: event.venue.venueId,
				displayedName: event.venue.displayedName,
				website: event.venue.website,
			} : undefined,
			link: event.link,
			publicNotes: event.publicNotes,
			toolIconMessage: event.eventType.toolNameLabelKey ? `The ${event.eventType.toolNameLabelKey} will be automatically enabled during this time.` : '',
			toolEventTime: this.util.date.formatUTC(event.toolStartUTC, 'DOW MMM D, YYYY', 'H:MM AM EST', 'en-US'),
			toolDuration: this.util.date.calculateTimePeriod(event.toolStartUTC, event.toolEndUTC),
		}
	});



	public toolIconClick(message: string) {
		window.alert(message);
	}


	public async openPersonDialog() {
		const event = this.eventDetails();
		if (!event) return;
		await this.dialogService.showCustom(PersonDialog, { data: { personId: event.hostPersonId, toEdit: false } }, 800, 800);
	}
}